import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonCloudStudioModule } from 'common-cloudstudio';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { IncidentSharedModule } from './incident-shared/incident-shared.module';
import { IncidentFormModule } from './incident-form/incident-form.module';
import { IncidentManagementModule } from './incident-management/incident-management.module';
import { IncidentMapModule } from './incident-map/incident-map.module';
import { IncidentFileModule } from './incident-file/incident-file.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonCloudStudioModule,
    TooltipModule.forRoot(),
    BsDropdownModule,
    IncidentSharedModule,
    IncidentFormModule,
    IncidentFileModule,
    IncidentManagementModule,
    IncidentMapModule,
  ],
  declarations: [ ],
  exports: [ 
    IncidentSharedModule,
    IncidentFormModule,
    IncidentFileModule,
    IncidentManagementModule,
    IncidentMapModule,
  ],
})
export class IncidentsModule {}
